import { Box } from "@material-ui/core";
import { FC } from "react";

import RejectRequest from "./RejectRequest";
import AcceptRequest from "./AcceptRequest";
import CancelRequests from "./CancelRequests";
import { RequestStatus } from "../types";

const ListRowActions: FC<any> = (props) => {
  const request = props.record;

  return (
    <>
      {request.type !== "entertainment" && (
        <Box display="flex" alignItems="center">
          {request.status === RequestStatus.pending && (
            <>
              <AcceptRequest record={request} />
              <RejectRequest record={request} />
            </>
          )}
          {request.status === RequestStatus.confirmed && <CancelRequests record={request} />}
        </Box>
      )}
    </>
  );
};

export default ListRowActions;
